import '@src/configs/i18n'
import '@src/@core/components/ripple-button'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'
import 'react-perfect-scrollbar/dist/css/styles.css'
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss'
import '@src/@core/assets/fonts/feather/iconfont.css'
import '@src/@core/scss/core.scss'
import '@src/assets/scss/style.scss'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import '@styles/react/libs/react-select/_react-select.scss'
import '@styles/react/libs/tables/react-dataTable-component.scss'
import '@src/utility/otel'

import {ApolloProvider} from '@apollo/client/react'
import themeConfig from '@configs/themeConfig'
import {FeaturesProvider} from '@pagaleve/features-lib'
import Spinner from '@src/@core/components/spinner/Fallback-spinner'
import clientOnboarding from '@src/api/pagaleve/public-onboarding/client'
import {useMerchantStore} from '@src/store/merchant'
import {ThemeContext} from '@src/utility/context/ThemeColors'
import {fingerprintjsLoad} from '@src/utility/fingerprints'
import {gtagInit} from '@src/utility/gtag'
import {logger} from '@src/utility/logger'
import {sentryInit} from '@src/utility/sentry'
import {store} from '@store/store'
import posthog from 'posthog-js'
import {PostHogProvider} from 'posthog-js/react'
import React, {lazy, Suspense} from 'react'
import {createRoot} from 'react-dom/client'
import {Toaster} from 'react-hot-toast'
import {Provider} from 'react-redux'
import {BrowserRouter} from 'react-router-dom'

const environment = import.meta.env.VITE_ENVIRONMENT === 'development' ? 'stage' : import.meta.env.VITE_ENVIRONMENT

let user = {}

const {
  input: {business_corporate_name, email, ...rest},
  leadId
} = useMerchantStore.getState()

if (leadId) {
  user = {email, id: leadId, username: business_corporate_name, ...rest}
}

sentryInit(user)
gtagInit()

void fingerprintjsLoad()

// eslint-disable-next-line @typescript-eslint/no-floating-promises
logger.init()

const LazyApp = lazy(() => import('./App'))

const container = document.getElementById('root')
const root = container && createRoot(container)

root &&
  root.render(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <FeaturesProvider environment={environment} project='onboarding-webapp'>
      <ApolloProvider client={clientOnboarding}>
        <BrowserRouter>
          <Provider store={store}>
            <Suspense fallback={<Spinner />}>
              <ThemeContext>
                <PostHogProvider client={posthog}>
                  <LazyApp />
                  <Toaster
                    position={themeConfig.layout.toastPosition}
                    toastOptions={{
                      className: 'react-hot-toast'
                    }}
                  />
                </PostHogProvider>
              </ThemeContext>
            </Suspense>
          </Provider>
        </BrowserRouter>
      </ApolloProvider>
    </FeaturesProvider>
  )
